export default "/images/Adhesives.webp?8efe0810021e6ad4dfebc759dcdf2b1f";